import Head from 'next/head';
import { Box, Container, Typography} from '@mui/material';
import { DashboardLayout } from '../dashboard-layout';

import app from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { useParams } from 'react-router-dom';
import ItemCard from './ItemCard';

const AddItem = () => {
  const { id } = useParams();
  
  return (
    <>
      <Head>
        <title>
          Modifier produit
        </title>
      </Head>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 3
        }}
      >
        <Container maxWidth="md">
          <Typography
            sx={{ mb: 3 }}
            variant="h4"
          >
            Modifier les détails du produit
          </Typography>
          <ItemCard itemId={id} isUpdate={true}/>
        </Container>
      </Box>
    </>
  );
}

AddItem.getLayout = (page) => (
  <DashboardLayout>
    {page}
  </DashboardLayout>
);

export default AddItem;
